module.exports = __webpack_public_path__ + "img/carInfo.c57dadc7.png";